// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"392":"d192b0a9","443":"d192b0a9","677":"0691463e"}[chunkId] + ".chunk.css";
};